export interface DeleteWallpaperResponse {
  success: boolean
  data: unknown
}
